// extracted by mini-css-extract-plugin
export default {"delineator":"styles_delineator__ABxfH"};